import React, { useEffect, useRef } from "react";
import "./HistorySection.css";
import { ListGroup } from "react-bootstrap";
import UIConfig from "../../../common/constants/UIConfig";

const HistorySection = ({ sizeLg, chats }) => {
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [chats]);
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: UIConfig.branding.timeZone || "America/New_York",
    };

    return date.toLocaleString("en-US", options);
  };

  

  console.log(chats)
  return (
    <div className="chat-container">
      <ListGroup ref={listRef} className={`chat-list ${sizeLg ? "lg" : ""}`}>
        {/* Check if chats is not undefined or an empty array */}
        {chats && chats.length > 0 ? (
          chats.map(
            (chat) =>
              chat && ( // Ensure chat is not null
                <ListGroup.Item
                  key={chat.id}
                  className="d-flex align-items-start chat-item"
                  style={{ border: "none" }}
                >
                  <div>
                    <div className="chat-header d-flex justify-content-start">
                      <strong className="chat-agent-name">
                        {chat.agentName ? chat.agentName.replace(/\s*null\b/gi, "").trim() : "Unknown Agent"}
                      </strong>
                      <small className="chat-created-on">
                        {formatDate(chat.createdOn)}
                      </small>
                    </div>
                    <p className="chat-message">{chat.notes}</p>
                  </div>
                </ListGroup.Item>
              )
          )
        ) : (
          <p>No chat history available</p> // Handle empty or undefined chats array
        )}
      </ListGroup>
    </div>
  );
};

export default HistorySection;
